var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "bottom", width: "600", trigger: "hover" } },
    [
      _vm.ticketOrigin
        ? _c("div", [
            _c("div", [
              _c("b", [_vm._v("ID:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticketOrigin.id))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v("IP:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticketOrigin.remoteAddr))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v("Referer:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticketOrigin.referer))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v("UserAgent:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticketOrigin.userAgent))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v("创建于:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticketOrigin.createdAt))])
            ])
          ])
        : _c(
            "div",
            {
              staticStyle: {
                "min-height": "100px",
                "text-align": "center",
                "font-size": "75px",
                color: "#d0d0d0"
              }
            },
            [_vm._v("未 知 " + _vm._s(_vm.ticketOrigin))]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ticketOrigin_0",
          attrs: { slot: "reference" },
          slot: "reference"
        },
        [
          _c("UserAgent", {
            model: {
              value: _vm.ticketOrigin,
              callback: function($$v) {
                _vm.ticketOrigin = $$v
              },
              expression: "ticketOrigin"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cc4a735", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc4a735","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketOrigin.vue
// module id = 886
// module chunks = 75